import PropTypes from 'prop-types'
import {
  Table, Button, Tag, Popconfirm,
} from 'antd'
import { EditTwoTone, DeleteTwoTone, PlusOutlined } from '@ant-design/icons'
import history from 'utils/history'
import Browser from '../../../utils/Browser'
const UserList = ({
  data, isLoading, handleDelete,
  handleChangePage
}) => {
  console.log("data api:",data)
  const columns = [
    {
      title: 'No',
      dataIndex: '',
      key: 'No',
      width: 80,
      render: (text, record, index) => (data.meta.limit * (data.meta.page - 1)) + index + 1,
    },
    {
      title: 'Nama',
      dataIndex: 'name',
      key: 'name',
      render: text => text || '-',
    },
    {
      title: 'No. Telepon',
      dataIndex: 'phone',
      key: 'phone',
      render: text => text || '-',
    },
    {
      title: 'Posisi',
      dataIndex: 'position',
      key: 'position',
      render: text => text || '-',
    },
    {
      title: 'Peran',
      dataIndex: 'role',
      key: 'role',
      render: text => text?.name || '-',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: text => <Tag color={text === 'active' ? 'green' : 'red'}>{text}</Tag>,
    },
    {
      title: 'Aksi',
      dataIndex: '',
      key: 'action',
      width: 80,
      render: (text, record) => (
        <div className="d-flex justify-content-center">
          <EditTwoTone twoToneColor="#faad14" className="mr-2" onClick={()=> Browser.setWindowHref(`/user/${record.id}/edit`)} />
          <Popconfirm
            title="Apa Anda yakin ingin menghapus Pengguna?"
            okText="Ya"
            cancelText="Tidak"
            placement="topLeft"
            onConfirm={() => handleDelete(record.id)}
          >
            <DeleteTwoTone twoToneColor="#ff4d4f" />
          </Popconfirm>
        </div>
      ),
    },
  ]

  return (
    <div>
      <div className="pb-3">
        <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
          <h3 className="title-content mb-0">Daftar Pengguna</h3>
          <Button type="primary" icon={<PlusOutlined />} href='/user/add'>
            Tambah pengguna
          </Button>
        </div>
      </div>
      <Table
        rowKey="id"
        className="table-striped-rows"
        columns={columns}
        dataSource={data.list}
        loading={isLoading}
        pagination={{
          total: data?.meta?.total,
          pageSize: data?.meta?.limit || 10,
          onChange: handleChangePage
        }}
      />
    </div>
  )
}

UserList.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  handleDelete: PropTypes.func,
  handleChangePage: PropTypes.func,
}

export default UserList
